import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { loading: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    root: {
      marginTop: 4,
      marginBottom: 32,
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 18,
      },
    },
    fieldsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      gap: 24,

      '& > div': {
        [mediaQuery(breakpoints.tablet)]: {
          flex: '100% !important',
        },
      },
    },

    buttonContainer: {
      zIndex: 100,
      backgroundColor: 'transparent',
      width: '100%',
      marginTop: 24,

      [mediaQuery(breakpoints.laptop)]: {
        bottom: 0,
        padding: [12, 24],
      },
    },

    buttonContainerWithDetails: {
      marginTop: 24,
    },

    advancedDetails: {
      'user-select': 'none',
      '-moz-user-select': 'none',
      '-webkit-user-select': 'none',
      '-ms-user-select': 'none',
      cursor: 'pointer',
      color: 'var(--x-accent-2-1)',
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: FontWeight.SemiBold,
      marginTop: 16,
      flex: '100%',
    },

    advancedDetailsArrow: {
      cursor: 'pointer',
      marginRight: 8,
      verticalAlign: 'middle',
    },

    generateButton: {
      borderRadius: 24,
      width: '100%',
      fontSize: '16px',
      padding: ({ loading }) => (loading ? '0px 16px' : '10px 16px'),
    },
    toneTooltipClassName: {
      top: '-76px',
    },
  }),
  { name: 'FormContent' },
);
export default useStyles;
